import { type Color } from '@mui/material'

export const orange = {
  100: '#180D00',
  200: '#3D1F01',
  300: '#7A3F01',
  400: '#9F5101',
  500: '#C36402',
  600: '#F69735',
  700: '#F8B167',
  800: '#FBCB9A',
  900: '#FDE5CC',
} satisfies Partial<Color>
